import { Deserializable } from '../protocols/deserializable';

export class VariableBenefitPaymentAccountEstimate implements Deserializable {
  public governingJurisdictionId!: number | null;
  public recurringPaymentAmount!: number | null;
  public minimumPaymentAmount!: number | null;
  public maximumPaymentAmount!: number | null;
  public recurringAnnualTotal!: number;
  public lumpSumTotal!: number;
  public estimatedAnnualTotal!: number;
  public startsInALaterYear!: boolean;
  // The submit's refusal, word for word, or null when the submit would accept it
  public refusal!: string | null;
  public overMaximumWarning!: boolean;
  public belowMinimumWarning!: boolean;

  public onDeserialize(): void {}
}
